import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const UnfilledHeart = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/heart">
        <g id="heart">
          <path
            id="Vector"
            d="M8.0026 14.4336C7.79594 14.4336 7.59594 14.4069 7.42927 14.3469C4.88261 13.4736 0.835938 10.3736 0.835938 5.79356C0.835938 3.46023 2.7226 1.56689 5.0426 1.56689C6.16927 1.56689 7.2226 2.00689 8.0026 2.79356C8.78261 2.00689 9.83594 1.56689 10.9626 1.56689C13.2826 1.56689 15.1693 3.46689 15.1693 5.79356C15.1693 10.3802 11.1226 13.4736 8.57594 14.3469C8.40927 14.4069 8.20927 14.4336 8.0026 14.4336ZM5.0426 2.56689C3.27594 2.56689 1.83594 4.01356 1.83594 5.79356C1.83594 10.3469 6.21594 12.8802 7.75594 13.4069C7.87594 13.4469 8.13594 13.4469 8.25594 13.4069C9.78927 12.8802 14.1759 10.3536 14.1759 5.79356C14.1759 4.01356 12.7359 2.56689 10.9693 2.56689C9.95594 2.56689 9.01594 3.04023 8.40927 3.86023C8.2226 4.11356 7.79594 4.11356 7.60927 3.86023C6.98927 3.03356 6.05594 2.56689 5.0426 2.56689Z"
          />
        </g>
      </g>
    </svg>
  );
};

UnfilledHeart.displayName = 'UnfilledHeart';
